function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 120.572,
    x2: 474.916,
    y1: 351.939,
    y2: 351.939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00376F"
    },
    stopColor: "#00376f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004E99"
    },
    stopColor: "#004e99"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M314.933 505.421c66.624-15.41 123.285-56.83 158.723-112.986 4.324-6.852-3.301-15.047-10.441-11.216-27.244 14.615-59.578 23.083-94.262 23.083-96.132 0-174.251-65.027-175.862-145.758-.544-27.28 15.737-51.398 39.363-61.48l-.016-.011c-13.967 4.889-29.673 6.91-41.82 15.331-46.071 31.936-74.038 91.028-69.583 144.152 4.324 51.55 35.847 111.958 90.373 138.946 28.515 14.113 65.299 11.816 103.525 9.939z",
    style: {
      fill: "url(#a)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 105.724,
    x2: 402.175,
    y1: 90.282,
    y2: 265.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00C2DD"
    },
    stopColor: "#00c2dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00D34F"
    },
    stopColor: "#00d34f"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.618 333.416c17.271 6.302 36.319 9.795 56.335 9.795 78.436 0 142.02-53.612 142.022-119.745C510.975 92.357 388.69 1.185 259.396.012 118.43-1.269 2.319 112.649 1.035 253.615c0 0 35.268-108.92 161.25-108.92 85.246 0 144.847 50.601 154.637 88.852a63.814 63.814 0 0 1 4.06 22.453c0 16.57-6.302 31.668-16.639 43.029-10.242 11.256-6.022 29.17 8.275 34.387z",
    style: {
      fill: "url(#b)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 133.488,
    x2: 213.342,
    y1: 141.756,
    y2: 508.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#006393"
    },
    stopColor: "#006393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "#0086DE"
    },
    stopColor: "#0086de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#006393"
    },
    stopColor: "#006393"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M316.922 233.547c-9.789-38.251-42.391-111.963-148.293-111.963-162.84 0-167.594 132.031-167.594 132.031C-.262 396.094 114.845 512 257.024 512c19.917 0 39.301-2.276 57.909-6.579-206.514 10.141-227.724-257.532-82.494-308.368l.016.011a62.35 62.35 0 0 1 23.873-5.018c27.721-.295 51.424 17.051 60.594 41.501z",
    style: {
      fill: "url(#c)"
    },
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.5c53b4b46353ad1e27c1ea23708302fb.svg";
export { ForwardRef as ReactComponent };